import { always, compose } from 'ramda';

import { FOUR_O_FOUR } from 'app/router/constants/paths';
import { redirectIfNotOnPath } from 'app/router/ExternalRedirect';

const redirectToFourOFour = compose(redirectIfNotOnPath, always(FOUR_O_FOUR));

export default redirectToFourOFour;
